import { TypeModal } from '../errors';

export enum CommonErrorType {
  NOT_FOUND = 'NOT_FOUND',
  BAD_CREDENTIALS_EXCEPTION = 'BAD_CREDENTIAL_EXCEPTION',
  METHOD_NOT_SUPPORTED_EXCEPTION = 'METHOD_NOT_SUPPORTED_EXCEPTION',
  ILLEGAL_ARGUMENT_EXCEPTION = 'ILLEGAL_ARGUMENT_EXCEPTION',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NO_HANDLER_FOUND_EXCEPTION = 'NO_HANDLER_FOUND_EXCEPTION',
  RESOURCE_NOT_FOUND_EXCEPTION = 'RESOURCE_NOT_FOUND_EXCEPTION',
  RESOURCE_DUPLICATED_EXCEPTION = 'RESOURCE_DUPLICATED_EXCEPTION',
  INVALID_ARGUMENT_EXCEPTION = 'INVALID_ARGUMENT_EXCEPTION',
  INVALID_ARGUMENTS_RELATION_EXCEPTION = 'INVALID_ARGUMENTS_RELATION_EXCEPTION',
  BUSINESS_EXCEPTION = 'BUSINESS_EXCEPTION',
  LIMIT_EXCEEDED_EXCEPTION = 'LIMIT_EXCEEDED_EXCEPTION',
  UPLOAD_EXCEPTION = 'UPLOAD_EXCEPTION',
  GENERIC_EXCEPTION = 'GENERIC_EXCEPTION',
  BLACKLIST_CHARACTERS_EXCEPTION = 'BLACKLIST_CHARACTERS_EXCEPTION',
  REQUEST_CONVERSION_EXCEPTION = 'REQUEST_CONVERSION_EXCEPTION',
  OUT_OF_SERVICE_TIME_EXCEPTION = 'OUT_OF_SERVICE_TIME_EXCEPTION',
  SERVICE_MAINTENANCE_EXCEPTION = 'SERVICE_MAINTENANCE_EXCEPTION',
  ECONNABORTED = 'ECONNABORTED',
  ERR_NETWORK = 'ERR_NETWORK',
}

export enum HttpStatusCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  RequestTimeout = 408,
  Conflict = 409,
  InternalServerError = 500,
  ServiceUnavailable = 503,
}

export enum Command {
  SHOW_DIALOG = 'show-dialog',
  NAVIGATE = 'navigate',
  NONE = '',
}

export const HTTP_COMMON_ERROR_TOPIC = 'http-common-error:occur';

export interface BusinessExceptionProps {
  errorCode: string;
  errorMsg: string;
  type: TypeModal;
}
